import React, { useCallback } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import { ActionButton } from 'components/action-button';
import { Modal } from 'components/modal';
import { useServiceModeCategory } from 'pages/store-locator/new-ui/hooks/use-service-mode-category';
import { useCdpContext } from 'state/cdp';
import { CustomEventNames } from 'state/cdp/constants';
import { routes } from 'utils/routing';
import { ServiceModeCategory } from 'utils/service-mode';

import { Header } from './modal-header';
import { Container, Content, P } from './styled';

export const NoStoresDeliveryModal = () => {
  const { formatMessage } = useIntl();
  const cdp = useCdpContext();
  const navigate = useNavigate();

  const { setServiceModeCategory } = useServiceModeCategory();

  const onFindRestaurantsClick = useCallback(() => {
    cdp.logNavigationClick(CustomEventNames.BUTTON_CLICK_NO_DELIVERY_OFFER_FIND_RESTAURANTS);
  }, [cdp]);

  const onShowMeDealsClick = useCallback(() => {
    cdp.logNavigationClick(CustomEventNames.BUTTON_CLICK_NO_DELIVERY_OFFER_SHOW_DEALS);
  }, [cdp]);

  const onDismiss = useCallback(() => {
    if (ServiceModeCategory.DELIVERY) {
      setServiceModeCategory(ServiceModeCategory.PICKUP);
    }
    navigate(routes.storeLocator);
  }, [navigate, setServiceModeCategory]);

  const modalHeading = formatMessage({ id: 'itsUsNotYou' });
  const modalBody = formatMessage({ id: 'deliveryIsUnavailable' });

  return (
    <Modal
      onDismiss={onDismiss}
      eventData={{
        modalAppearanceEventMessage: 'Delivery not available in your area',
        modalMessage: modalBody,
      }}
    >
      <Content>
        <Container>
          <Header id="modal-heading">{modalHeading}</Header>
          <P>{modalBody}</P>
        </Container>

        <Box margin="2rem 0" width="100%" flexDirection="column" align="center">
          <ActionButton to={routes.storeLocator} onClick={onFindRestaurantsClick}>
            {formatMessage({ id: 'noRestaurantDeliveryCta' })}
          </ActionButton>
          <Box margin="1rem 0 0 0">
            <ActionButton to={routes.offers} onClick={onShowMeDealsClick}>
              {formatMessage({ id: 'showMeDeals' })}
            </ActionButton>
          </Box>
        </Box>
      </Content>
    </Modal>
  );
};
